import React, { ComponentProps } from 'react';
import Hyperlink from '../../components/atoms/Hyperlink/Hyperlink';
import { BlockGuard } from '../../types/api/Block';
import { BlockType } from '../../types/api/ElementType';
import IUrl from '../../types/IUrl';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { asBlock } from '../../_lib/BlockFetcher';
import { useSonTranslation } from '../../translation/useSonTranslation';

type LoginLogoutProps = {
  loginUrl: IUrl;
  logoutUrl?: IUrl;
};

export function LoginLogoutNoScript({ loginUrl, logoutUrl }: LoginLogoutProps) {
  const { userInfo } = useAppContext();
  const { t } = useSonTranslation('glossary');

  const isLoggedIn = userInfo?.loggedIn;
  return (
    <noscript>
      <Hyperlink
        to={isLoggedIn && logoutUrl ? logoutUrl.url : loginUrl.url}
        routing={false}
        className="header__login-logout-link"
      >
        {isLoggedIn ? t('logout') : t('login')}
      </Hyperlink>
    </noscript>
  );
}

export const LoginLogoutNoScriptBlock = asBlock(LoginLogoutNoScript);
export type LoginLogoutNoScriptBlock = ComponentProps<typeof LoginLogoutNoScriptBlock>;
export const isLoginLogoutNoScriptBlock = BlockGuard<LoginLogoutNoScriptBlock>(BlockType.loginLogout);
